import { render, staticRenderFns } from "./CallingPlanRecommanded.vue?vue&type=template&id=6688ad24"
import script from "./CallingPlanRecommanded.vue?vue&type=script&lang=js"
export * from "./CallingPlanRecommanded.vue?vue&type=script&lang=js"
import style0 from "./CallingPlanRecommanded.vue?vue&type=style&index=0&id=6688ad24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports